import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const VISION_INIT = 'VISION/INIT';

export interface IVisionInitPayload {
  faceDetectionRate: number;
  imageWidth: number;
}

export const visionInitPayloadSchema = objectSchemaOf<IVisionInitPayload>({
  faceDetectionRate: Joi.number().required(),
  imageWidth: Joi.number().required(),
});

export interface IVisionInitAction {
  type: typeof VISION_INIT;
  payload: IVisionInitPayload;
}

export const visionInitActionSchema = objectSchemaOf<IVisionInitAction>({
  type: Joi.string().required().valid(VISION_INIT),
  payload: visionInitPayloadSchema.required(),
});

export const visionInit = actionCreator({
  type: VISION_INIT,
  schema: visionInitActionSchema,
});
